import { render, staticRenderFns } from "./WalkieTalkie.vue?vue&type=template&id=2c28ab59&scoped=true&"
import script from "./WalkieTalkie.vue?vue&type=script&lang=js&"
export * from "./WalkieTalkie.vue?vue&type=script&lang=js&"
import style0 from "./WalkieTalkie.vue?vue&type=style&index=0&id=2c28ab59&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c28ab59",
  null
  
)

export default component.exports